import React, { Fragment } from "react";

import { SupText, SupSuperformMorph } from "@repo/core-ui";

import { formatCurrencyCompact } from "@/utils";
import dappConfig from "@/../config/dapp.config";

interface PortfolioSummaryBadgeProps {
  type: "apy" | "fiat";
  value: number;
  caption: string;
  notation?: "standard" | "compact";
}

export default function PortfolioCommonBadge({ value, type = "fiat", caption, notation = "standard" }: PortfolioSummaryBadgeProps) {
  const formattedValue =
    type == "apy"
      ? `${value.toFixed(dappConfig.decimalsApyRoundingLimit)}%`
      : formatCurrencyCompact(parseFloat(`${value}`), dappConfig.decimalsRoundingLimit, 0, "currency", notation);

  const [captionPart1, captionPart2] = caption.split(" ");

  return (
    <div className="flex h-7 items-stretch overflow-hidden rounded-l-[16px] rounded-br-[16px] border-0.5 border-primary-600 bg-primary-25">
      <div className="flex items-center space-x-2 whitespace-nowrap px-2 py-1 text-primary-700">
        <SupSuperformMorph />
        <SupText variant="caption">
          {captionPart2 ? (
            <Fragment>
              <span className="hidden md:inline">{captionPart1}</span> {captionPart2}
            </Fragment>
          ) : (
            caption
          )}
        </SupText>
      </div>
      <SupText variant="caption" weight="black" family="sans" className="flex items-center border-l-0.5 border-neutral-600 px-2">
        {formattedValue}
      </SupText>
    </div>
  );
}
